// extracted by mini-css-extract-plugin
module.exports = {"app":"src_app__LvvQC","appDark":"src_appDark__mvigR"};